<template>
  <div id="appDetailView">
    <h1 style="text-align: center">应用详情</h1>
    <a-card>
      <a-row style="margin-bottom: 16px">
        <a-col flex="auto" class="content-wrapper">
          <h2>{{ data.appName }}</h2>
          <p>应用描述：{{ data.appDesc }}</p>
          <p>应用类型：{{ APP_TYPE_MAP[data.appType!] }}</p>
          <P
            >应用策略：{{ APP_SCORING_STRATEGY_MAP[data.scoringStrategy!] }}
          </P>
          <p>
            作者：
            <a-avatar
              :size="24"
              :style="{ marginRight: '8px' }"
              :image-url="data.user?.userAvatar"
            >
            </a-avatar>
            <a-typography-text>
              {{ data.user?.userName || "匿名" }}
            </a-typography-text>
          </p>
          <p>
            创建时间：
            {{ dayjs(data.createTime).format("YYYY-MM-DD HH:mm:ss") }}
          </p>
          <a-space size="medium">
            <a-button type="primary" :href="`/answer/do/${id}`"
              >开始答题
            </a-button>
            <a-button @click="doShare">分享应用</a-button>
            <a-button v-if="isMy" :href="`/add/question/${id}`"
              >设置题目
            </a-button>
            <a-button v-if="isMy" :href="`/add/scoring_result/${id}`"
              >设置评分
            </a-button>
            <a-button v-if="isMy" :href="`/add/app/${id}`">修改应用</a-button>
          </a-space>
        </a-col>
        <a-col flex="320px">
          <div>
            <a-image :src="data?.appIcon" :alt="data?.appName" width="100%" />
          </div>
        </a-col>
      </a-row>
    </a-card>
    <ShareModal :link="shareLink" title="应用分享" ref="shareModalRef" />
  </div>
</template>

<script setup lang="ts">
import { getAppVoByIdUsingGet } from "@/api/appController";
//@ts-ignore
import { ref, watchEffect, withDefaults, defineProps, computed } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import dayjs from "dayjs";
import { useLoginUserStore } from "@/store/useStore";
import ShareModal from "@/components/ShareModal.vue";

const data = ref<API.AppVO>({});

interface Props {
  id: string;
}

const prop = withDefaults(defineProps<Props>(), {
  id: () => "",
});
// 加载数据
const loadData = async () => {
  if (!prop.id) {
    message.error("应用不存在");
    return;
  }
  const res = await getAppVoByIdUsingGet({ id: prop.id as any });
  if (res.data.code === 0) {
    data.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

/**
 * 监听 searchParams 变量：触发加载
 */
watchEffect(() => {
  loadData();
});

//获取登录用户
const loginUserStore = useLoginUserStore();
let loginUserId = loginUserStore.loginUser?.id;

//是不是本人创建的应用
const isMy = computed(() => {
  return loginUserId && loginUserId === data.value.userId;
});

// 分享弹窗的引用
const shareModalRef = ref();

// 分享链接
const shareLink = `${window.location.protocol}//${window.location.host}/app/detail/${prop.id}`;

// 分享
const doShare = (e: Event) => {
  if (shareModalRef.value) {
    shareModalRef.value.openModal();
  }
  // 阻止冒泡，防止跳转到详情页
  e.stopPropagation();
};
</script>

<style scoped>
#appDetailView {
}

#appDetailView .content-wrapper > * {
  margin-bottom: 24px;
}
</style>
